import videoRation from './video-ration';

const handleVimeoVideo = ($video) => {
    if ($video.length) {
        const $videoInner = $video.find('.video__inner');

        const player = new Vimeo.Player($videoInner.attr('id'), {
            id: $videoInner.data('video-id'),
            autoplay: true,
            background: true,
            muted: true,
            controls: false,
            loop: true
        });

        player.on('loaded', function() {
            $video.addClass('video--is-play');

            videoRation($video);

            player.play();
        });

        player.on('ended', function() {
           player.play();
        });


        $(window).on('resize', function() {
            videoRation($video);
        });
    }
}

export default handleVimeoVideo;
